module.exports = __webpack_public_path__ + "static/media/github.5cd9f30e.png";